import classes from "./media_manager_edit.module.scss";
import CellWrapper from "@common-components/tasks/columns-cells/cell-wrapper";
import { columnTypeList } from "@common-components/tasks/columns-cells/column-cell-defs";
import { getSelectedBoardId } from "@common-reducers/BoardsSelectors";
import { tasksSelectOneFieldById } from "@common-reducers/DBServiceThunks";
import { dynamicColumnsListOfIdsTypesAndTitles } from "@common-reducers/TaskSelectors";
import { getIconByType } from '@common/components/tasks/columns-cells/column-cell-defs';
import { useAppSelector } from "@common-reducers/hooks/store.hook";

// Column types that render their own colored background — for these we keep the
// cell area transparent instead of adding the muted card fill.
const SELF_STYLED_COLUMNS = ['timeline-picker', 'option-picker', 'status-option-picker', 'complexity-picker'];

export default function MediaMangerEdit() {
    const taskId = useAppSelector((state) => state.MediaManagerReducer.taskId);
    const selectedBoardId = useAppSelector(getSelectedBoardId);
    const taskBoardId = useAppSelector((state) => tasksSelectOneFieldById(state.DBTasksReducer, taskId, "boardId"));
    // Resolve columns from the file's own board, falling back to the selected board.
    const boardId = (typeof taskBoardId === 'string' && taskBoardId) ? taskBoardId : selectedBoardId;
    const columnsListOfIds = useAppSelector((state) => dynamicColumnsListOfIdsTypesAndTitles(state, boardId))
    const groupIdRaw = useAppSelector((state) => tasksSelectOneFieldById(state.DBTasksReducer, taskId, "groupId"))
    const groupId = typeof groupIdRaw === 'string' ? groupIdRaw : undefined;

    const ColumnRow = (column: readonly [string, string, string?, string?], index: number) => {
        const [cell] = columnTypeList.filter((columnType) => columnType.type === column[1]);
        if (!cell?.cellComponent) return null;
        const selfStyled = SELF_STYLED_COLUMNS.indexOf(column[1]) !== -1;

        return (
            <div key={`${index}_${column[0]}`} className={classes.card}>
                <div className={classes.cardHeader}>
                    <span className={classes.cardIcon}>{getIconByType(column[1])}</span>
                    <span className={classes.cardTitle}>{column[2] ?? column[1]}</span>
                </div>
                <div className={`${classes.cardCell} ${selfStyled ? classes.cardCellPlain : ''}`}>
                    <CellWrapper
                        columnId={column[0]}
                        taskId={taskId}
                        groupId={groupId}
                        boardId={boardId}
                        cellComponent={cell.cellComponent}
                        isOnKanban
                    />
                </div>
            </div>
        )
    }

    return (
        <div className={classes.wrapper}>
            <div className={classes.panelHeader}>Edit fields</div>
            <div className={classes.cardList}>
                {columnsListOfIds.length === 0 ? (
                    <div className={classes.emptyState}>No editable fields on this board</div>
                ) : (
                    columnsListOfIds.map((column, index) => ColumnRow(column, index))
                )}
            </div>
        </div>
    )
}
